<div class="input-group" (click)="datepicker.click()">
  <div class="input-group-append">
    <span class="input-group-text fs-xl"><i class="fal fa-calendar-alt"></i></span>
  </div>
  <input type="text" id="datepicker-modal-3" class="form-control" #datepicker
         daterangepicker [options]="options" autocomplete="off"
         (selected)="selectedDate($event, dateRange)"/>
</div>
